var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 110,
    viewBox: "0 0 110 110",
    width: 110,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.16663 100.833 21.31247-59.5831 38.6146 38.1563zm11.57287-11.5727 35.9792-12.8333-23.2604-23.375zm43.0834-30.25-3.8959-3.8958 27.5-27.5c2.4445-2.4445 5.5382-3.6858 9.2813-3.724 3.7427-.0382 6.8367 1.165 9.2817 3.6094l1.947 1.9479-3.895 3.8959-2.177-2.1771c-1.452-1.4514-3.1324-2.1962-5.0421-2.2344s-3.6285.7066-5.1563 2.2344zm-18.2188-17.7604-3.8958-3.8958 3.4375-3.4375c1.7569-1.757 2.5781-3.7622 2.4635-6.0157-.1145-2.2534-.9357-4.1441-2.4635-5.6718l-3.2083-3.2084 3.8958-3.8958 2.9792 2.9792c2.6736 2.6736 3.9913 6.0156 3.9531 10.026s-1.3941 7.3524-4.0677 10.026zm9.2813 8.8229-3.8959-3.8958 17.4167-17.4167c1.4514-1.4514 2.158-3.3038 2.1198-5.5573-.0382-2.2534-.783-4.1059-2.2344-5.5573l-6.9896-6.9896 3.8959-3.89579 7.2187 7.21879c2.3681 2.4444 3.5903 5.5191 3.6667 9.2239.0764 3.7049-1.1076 6.7795-3.5521 9.224zm18.1041 18.2188-3.8958-3.8959 5.3854-5.3854c2.6736-2.6736 5.882-4.0486 9.625-4.125 3.7431-.0764 6.9514 1.2222 9.625 3.8958l5.8438 5.8438-3.8959 3.8958-5.9583-5.9583c-1.7569-1.7569-3.5903-2.6354-5.5-2.6354s-3.743.8785-5.5 2.6354z",
    fill: "#00df90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTada);
export default __webpack_public_path__ + "static/media/icon-tada.587d3ee3c8f8dc7f4c416156f59bdacc.svg";
export { ForwardRef as ReactComponent };